import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Grid,
  Button,
  Divider,
  Select,
  MenuItem,
  Card,
  CardContent,
  SvgIcon,
} from "@mui/material";
import Shop from "../../../src/assests/images/shop.svg";
import Note from "../../../src/assests/images/note.svg";
import Location from "../../../src/assests/images/location.svg";
import { dashboardPriority } from "./api";
import { getToken } from "../../utils/utils";
interface User {
  id: number;
  fullName: string;
  outlet_name: string;
  location: string;
  total_points: string;
  redeemed_points: string;
  total_tasks: number;
  last_login_time: string;
  last_login: string;
}
const LineArrow = () => (
  <SvgIcon viewBox="0 0 24 24" sx={{ fontSize: "30px" }}>
    <path
      d="M7 10l5 5 5-5"
      stroke="currentColor"
      strokeWidth="2"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);


interface User {
  id: number;
  fullName: string;
  outlet_name: string;
  location: string;
  total_points: string;
  redeemed_points: string;
  total_tasks: number;
  last_login_time: string;
  last_login: string;
}


interface TaskNotCompletedProps {
  users: User[];
}

export default function TaskNotCompleted({ users }: TaskNotCompletedProps) {



  const [showAll, setShowAll] = useState(false);
  const visibleUsers = showAll ? users : users.slice(0, 5);


  



  return (
    <Box
      sx={{
        borderRadius: "8px",
        padding: "0px !important",
        backgroundColor: "#fff",
        boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
        border: "none",
        width: "100%",
        "& .css-19kzrtu": { padding: "0" }, // Target the class here
      }}
    >
      {visibleUsers.map((user, index) => (
        <Card
          key={index}
          sx={{
            marginBottom: "16px",
            border: "1px solid #e0e0e0",
            borderRadius: "8px",
            backgroundColor: "##E7E8E9 ",
            boxShadow: "none",
            padding: "0",
          }}
        >
          <CardContent>
            <Grid container spacing={1} alignItems="center">
              <Grid item xs={8}>
                <Typography
                  variant="body1"
                  fontWeight="bold"
                  sx={{ fontSize: "18px", color: "#282829", padding: "0" }}
                >
                  {user.fullName}
                </Typography>
                <Typography
                  variant="body2"
                  color="textSecondary"
                  sx={{ fontSize: "14px", color: "#7D7E7F", display: "flex", }}
                >
                  <Typography
                    sx={{
                      paddingRight: "15px",
                      position: "relative", fontSize: "14px",
                      "&:before": {
                        content: '"|"',
                        display: "inline-block",
                        marginRight: "5px",
                        color: "black",
                        position: "absolute",
                        right: "-5px",
                        top: "2px",

                      },
                    }}
                  >
                    <img
                      style={{
                        paddingRight: "5px",
                        paddingTop: "5px",
                        position: "relative",
                        top: "2px",
                      }}
                      src={Shop}
                      alt="Shop"
                    />
                    {user.outlet_name}
                  </Typography>

                  <Typography sx={{ paddingLeft: "15px" }}>
                    <img
                      style={{
                        paddingRight: "5px",
                        paddingTop: "5px",
                        position: "relative",
                        top: "2px",
                      }}
                      src={Location}
                      alt="Shop"
                    />
                    {user.location||""}
                  </Typography>
                </Typography>
              </Grid>
              <Grid item xs={4} textAlign="right">
                <Button
                  size="small"
                  sx={{
                    backgroundColor:
                      user.last_login === "Opened" ? "#FEDED8" : "#FEDED8",
                    color: user.last_login === "Opened" ? "#B90022" : "#B90022",
                    fontWeight: "bold",
                    borderRadius: "16px",
                    textTransform: "capitalize",
                    padding: "4px 12px",
                    fontSize: "14px",
                    width: "140px",
                    position: "relative",
                    left: "0px",
                  }}
                >
                  {user.last_login||""}
                </Button>
              </Grid>
            </Grid>
            <Box
              sx={{
                display: "flex",
                width: "100%",
                justifyContent: "space-between",
                textAlign: "center",
                margin: "0",
                padding: "0",
              }}
            >
              <Typography
                variant="body2"
                sx={{
                  marginTop: "0px",
                  fontSize: "12px",
                  color: "#7D7E7F",
                }}
              >
                <Typography
                  sx={{
                    width: "100%",
                    fontSize: "14px",
                    color: "#494A4B",
                    fontWeight: "600",
                    marginTop: "30px",
                  }}
                >
                  {user.total_points||""}
                </Typography>
                Total Points:
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  marginTop: "0px",
                  fontSize: "12px",
                  color: "#7D7E7F",
                }}
              >
                <Typography
                  sx={{
                    width: "100%",
                    fontSize: "14px",
                    color: "#494A4B",
                    fontWeight: "600",
                    marginTop: "30px",
                  }}
                >
                  {user.redeemed_points||""}
                </Typography>
                Redeemed Points:
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  marginTop: "0px",
                  fontSize: "12px",
                  color: "#7D7E7F",
                }}
              >
                <Typography
                  sx={{
                    width: "100%",
                    fontSize: "14px",
                    color: "#494A4B",
                    fontWeight: "600",
                    marginTop: "30px",
                  }}
                >
                  {user.total_tasks||""}
                </Typography>
                Total Tasks:
              </Typography>
            </Box>
          </CardContent>
        </Card>
      ))}
      {users.length > 5 && (
        <Button
          onClick={() => setShowAll(!showAll)}
          sx={{
            width: "100%",
            marginTop: "16px",
            textTransform: "capitalize",
            color: "#C8172F",
            fontWeight: "bold",
            fontSize: "14px",
          }}
        >
          {showAll ? "Show Less" : "View All"}
        </Button>
      )}
    </Box>
  );
}
